export async function disconnectLocoDroneT(land = false) {
  const lifecycle = window.__ldtSerialLifecycle;
  const session = lifecycle && window.serialport && lifecycle.sessions.get(window.serialport);
  if (!session) return;
  const commands = land ? [[76, 4, 0, 0, 0, 0], [70, 1, 0]] : [];
  await lifecycle.disconnect(session, commands);
}

export async function webserial_disconnect() {
  const lifecycle = window.__ldtSerialLifecycle;
  if (lifecycle && window.serialport && lifecycle.sessions.has(window.serialport)) {
    await disconnectLocoDroneT();
    return;
  }
  try {
    // Close the input stream (reader).
    if (window.reader) {
      await window.reader.cancel();
      window.reader = null;
    }
    // Close the output stream.
    if (window.outputStream) {
      await window.outputStream.getWriter().close();
      await window.outputDone;
      window.outputStream = null;
      window.outputDone = null;
    }
    // Close the port.
    await window.serialport.close();
    window.serialport = null;
    //log.textContent = "Dongle Disconnected!";
  } catch (err) {}
}

